import React, { Component, createRef } from 'react';
import gsap from "gsap";
import { URLImgFront } from '../../../config/URLDB';
import { hoverBoton, salidaBoton, focusBoton, blurBoton, animarContenido } from '../../../utils/Animaciones'

import { SegurosConfiguracion_ } from '../../../services/WebAPI_Utrahuilca';
import Swal from 'sweetalert2';
class Detalle_Seguro extends Component {
    constructor(props) {
        super(props);
        this.state = {
            opcion: true,
            seguros: [],
        };
        this.headerRef = createRef();
        this.botonesRef = createRef();
        this.contenidoRef = createRef();
        this.clausulaRef = createRef();
    }

    async componentDidMount() {
            await this.DatosProteccion();
            const lineaTiempo = gsap.timeline({ defaults: { ease: "power3.out" } });
        lineaTiempo.fromTo(
            this.headerRef.current,
            { opacity: 0, x: -60 },
            { opacity: 1, x: 0, duration: 0.7 }
        )
        .fromTo(
            this.botonesRef.current.querySelectorAll(".seguro-btn-detalle, .seguro-btn-regresar"),
            { opacity: 0, y: 30 },
            { opacity: 1, y: 0, duration: 0.5, stagger: 0.15 },
            "-=0.3"  
        )
        .fromTo(
            [this.contenidoRef.current, this.clausulaRef.current],
            { opacity: 0, x: 50 },
            { opacity: 1, x: 0, duration: 0.6 },
            "-=0.2"
        )
    }

    componentDidUpdate(prevProps) {
        if (prevProps.estado !== this.props.estado) {
            this.DatosProteccion();
        }
    }

    DatosProteccion = async () => {
        const { id, titulo, description } = this.props;
        const data = {
            tran: 6,
            idconfigseguitem: 0,
            idseguro: id,
            idseguitem: 0,
            titulo: "NA",
            descripcion: "NA",
            rutaicono: "NA",
            idtipoenlace: 0,
            rutaconfig: "NA",
            orden: 0,
            estado: 1,
            idusucrea: 0,
            feccrea: null,
        };

        try {
            const response = await SegurosConfiguracion_(data);
            const cantregistros = response?.length ?? 0;
            if (cantregistros > 0 && !response[0]?.message) {
                const planBase = {
                    id: id,
                    titulo: titulo || "",
                    description: description || "",
                    amparo: "",
                    asistencia: [],
                    requisito: "",
                    clausula: null,
                    compra: null
                };
                response.forEach(item => {
                    switch (item.idseguitem) {
                        case 4: // AMPAROS
                            planBase.amparo = item.descripcion;
                            break;

                        case 5: // REQUISITOS
                            planBase.requisito = item.descripcion;
                            break;

                        case 6: // ASISTENCIAS
                            planBase.asistencia.push(item.descripcion);
                            break;

                        case 7: // CLAUSULA
                            planBase.clausula = item.rutaconfig;
                            break;

                        default:
                            break;
                    }
                });
                this.setState({ seguros: [planBase] });

            } else {
                this.setState({ seguros: [] });
            }
        } catch (error) {
            Swal.fire({
                icon: 'error',
                text: 'Ocurrió un error al consumir el servicio'
            });
        }
    }; 

    cambiarOpcion = (idopcion) => {
        if (idopcion !== this.state.opcion) {
            animarContenido(this.contenidoRef.current, (animar) => {
                this.setState({ opcion: idopcion }, animar);
            });
        }
    };

    dividirColumnas = (data) => {
        if (!data) return [[], []];
        let lista = [];
        if (Array.isArray(data)) {
            lista = data.filter(item => item && item !== "");
        }
        else if (typeof data === "string") {
            lista = data.split(/<br\s*\/?>/i).map(item => item.trim()).filter(item => item !== "");
        } else {
            return [[], []];
        }

        const mitad = Math.ceil(lista.length / 2);

        return [
            lista.slice(0, mitad),
            lista.slice(mitad)
        ];
    };


    render() {
        const plan = this.state.seguros[0];
        if (!plan) return null;

        const asistencias = plan.asistencia;
        const [reqcolumna1, reqcolumna2] = this.dividirColumnas(plan.requisito);
        const [ampcolumna1, ampcolumna2] = this.dividirColumnas(plan.amparo);

        return (
            <React.Fragment>
                <div ref={this.headerRef} style={{ backgroundColor: '#EBFDFF' }}>
                    <div className="row align-items-center justify-content-center">
                        <div className="col-sm-auto py-4 justify-content-around d-flex">
                            <img src={this.props.ruta} className="seguro-card-detalle shadow" alt={plan.titulo} />
                        </div>
                        <div className="col-sm-6 py-4">
                            <h5 className="seguro-titulo"> {plan.titulo} </h5>
                            <p className="seguro-texto-descrip" style={{ marginBottom: "4px" }} dangerouslySetInnerHTML={{ __html: plan.description }} />
                        </div>
                    </div>
                </div>
                <div ref={this.botonesRef} className="row seguro-botones-container px-3 px-md-4 justify-content-center">
                    <div className="col-6 col-md-auto p-2 d-flex justify-content-center">
                        <button type="button" className="seguro-btn-detalle" onClick={() => this.cambiarOpcion(1)} onMouseEnter={hoverBoton} onMouseLeave={salidaBoton} onFocus={focusBoton("#37B3C1", "#ffffff")} onBlur={blurBoton("#ffffff", "#37B3C1")} autoFocus={true}>
                            AMPAROS
                        </button>
                    </div>
                    <div className="col-6 col-md-auto p-2 d-flex justify-content-center">
                        <button type="button" className="seguro-btn-detalle" onClick={() => this.cambiarOpcion(0)} onMouseEnter={hoverBoton} onMouseLeave={salidaBoton} onFocus={focusBoton("#37B3C1", "#ffffff")} onBlur={blurBoton("#ffffff", "#37B3C1")}>
                            REQUISITOS
                        </button>
                    </div>
                    <div className="col-6 col-md-auto p-2 d-flex align-items-center justify-content-center mb-3">
                        <div className="seguro-btn-regresar" onMouseEnter={hoverBoton} onMouseLeave={salidaBoton} onClick={() => this.props.onAccion(0)}>
                            <img src={`${URLImgFront}/assets/Seguros/BtnRegresar.webp`} alt="clausula" className="seguro-img-regresar " />
                        </div>
                    </div>
                </div>
                <div ref={this.contenidoRef}>
                    {this.state.opcion ? (
                        <div className="row justify-content-center">
                            <div className="col-md-auto mb-4">
                                <img src={`${URLImgFront}/assets/Seguros/Iconos/Amparos.svg`} className="align-self-center mr-3 seguro-icono" alt="Amparos"/>
                            </div>

                            <div className="col-md-auto" style={{ maxWidth: '75%' }}>
                                <div className="row">
                                    <div className="col-md-auto seguro-texto-descrip text-left">
                                        {ampcolumna1.map((linea, i) => (
                                            <p key= {`col1-${i}`} style={{ marginBottom: "4px" }}
                                            dangerouslySetInnerHTML={{ __html: linea }} />
                                        ))}
                                    </div>

                                    <div className="col seguro-texto-descrip text-left">
                                        {ampcolumna2.map((linea, i) => (
                                            <p key={`col1-${i}`} style={{ marginBottom: "4px" }}
                                            dangerouslySetInnerHTML={{ __html: linea }} />
                                        ))}
                                    </div>

                                    <div className="col-md-auto seguro-texto-descrip text-left" >
                                        {asistencias.filter(linea => linea && linea.trim() !== "" && linea.trim().toUpperCase() !== "NA").map((linea, i) => (
                                            <p key={i} style={{ marginBottom: "4px" }}
                                                dangerouslySetInnerHTML={{ __html: linea }}
                                            />
                                        ))}
                                    </div> 
                                </div>
                            </div>
                        </div>
                    ) : (
                    <div className="row justify-content-center">
                        <div className="col-md-auto mb-4">
                            <img src={`${URLImgFront}/assets/Seguros/Iconos/Requisitos.svg`} className="align-self-center mr-3 seguro-icono" alt="Requisitos"/>
                        </div>

                        <div className="col-md-auto" style={{ maxWidth: '75%' }}>
                            <div className="row">
                                <div className="col seguro-texto-descrip text-left">
                                    {reqcolumna1.map((linea, i) => (
                                        <p key={`col1-${i}`} style={{ marginBottom: "4px" }}
                                        dangerouslySetInnerHTML={{ __html: linea }} />
                                    ))}
                                </div>
                                <div className="col seguro-texto-descrip text-left">
                                    {reqcolumna2.map((linea, i) => (
                                        <p key={`col2-${i}`} style={{ marginBottom: "4px" }}
                                            dangerouslySetInnerHTML={{ __html: linea }} />
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                    )}
                </div>
                <div ref={this.clausulaRef} className="row align-items-center justify-content-center pb-5"> <a href={`${URLImgFront}/assets/${plan.clausula}`} target={'_blank'} rel={'noopener noreferrer'} onMouseEnter={hoverBoton} onMouseLeave={salidaBoton}> <img src={`${URLImgFront}/assets/Seguros/BtnClausula.webp`} alt="clausula" style={{ marginTop: '20px' }} /> </a> </div>
            </React.Fragment>
        );
    }
}
export default Detalle_Seguro;